/**
 * DuplicateGem use case: create a copy of a gem in a tower slot.
 */

import { duplicateGemInSlot } from "../../domain/session.js";
import type { DuplicateGemError } from "../../domain/types.js";
import type { RenderPort } from "../ports.js";
import { sessionToView } from "../state-view.js";
import type { GemSlot } from "../types.js";

export interface DuplicateGemDeps {
  render: RenderPort;
  getSession(): import("../../domain/session.js").GameSession | null;
}

export function createDuplicateGem(deps: DuplicateGemDeps) {
  return function duplicateGem(slot: GemSlot): { ok: true } | DuplicateGemError {
    const session = deps.getSession();
    if (!session) return { code: "InvalidSlot" };

    const tower = session.towers.find((t) => t.id === slot.towerId);
    if (!tower) return { code: "InvalidSlot" };
    const gemSlot = tower.gemSlots[slot.slotIndex];
    if (!gemSlot?.gem) return { code: "InvalidSlot" };

    const ok = duplicateGemInSlot(session, slot.towerId, slot.slotIndex);
    if (!ok) return { code: "NotEnoughMana" };

    deps.render.update(sessionToView(session, "game"));
    return { ok: true };
  };
}
